import React, { FC } from 'react';
import { NoDataCont } from './NoData.styles';

interface INoData {
  message: string
  height?: string;
}

const NoData:FC<INoData> = ({message, height}) => (
  <NoDataCont
    id="NoDataCont"
    data-testid='noDataInfo'
    height={height}
  >{message}</NoDataCont>
);

export default NoData;
